import React from "react";
import { specialClinic } from "./Datamenu_inc";
import { motion } from "framer-motion";

export const Clinic_1 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
        <span className="drop-shadow-lg">{specialClinic[0].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจ วินิจฉัย และรักษาโรคผิวหนัง เช่น ไรขี้เรื้อน,
          โรคติดเชื้อยีสต์หรือแบคทีเรีย, ภาวะภูมิแพ้,
          และภาวะความผิดปกติด้านฮอร์โมน
        </li>
        <li>
          หาสาเหตุของปัญหาโรคผิวหนัง เพื่อให้การรักษาเป็นไปอย่างมีประสิทธิภาพ
        </li>
        <li>
          ให้คำแนะนำเกี่ยวกับการดูแลสุขภาพผิว เช่น
          การอาบน้ำและการเลือกใช้แชมพูที่เหมาะสมกับสภาพผิวหนังของสัตว์เลี้ยง
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน{" "}
        <span className="drop-shadow-lg border-b">{specialClinic[0].name}</span>
        :
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2  gap-5">
        {specialClinic[0]?.vet.length > 0 &&
          specialClinic[0].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover drop-shadow-lg w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_2 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span className="drop-shadow-lg">{specialClinic[1].name}</span>
      </div>
      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคตา เช่น ต้อกระจก, แผลที่กระจกตา, และต้อหิน
        </li>
        <li>
          การรักษาทางอายุรกรรมและศัลยกรรม เพื่อแก้ไขความผิดปกติเกี่ยวกับดวงตา
        </li>
        <li>
          การใช้เครื่องมือและอุปกรณ์ทางการแพทย์ที่ทันสมัย
          โดยสัตวแพทย์ที่มีความเชี่ยวชาญและประสบการณ์
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน{" "}
        <span className="drop-shadow-lg border-b">{specialClinic[1].name}</span>
        :
      </div>

      <div
        className={`grid ${
          specialClinic[1]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[1]?.vet.length > 0 &&
          specialClinic[1].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_3 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span className="drop-shadow-lg">{specialClinic[2].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจ วินิจฉัย และรักษาความผิดปกติทางทันตกรรม: เช่น ฟันผุ โรคเหงือก
          และปัญหาช่องปากอื่นๆ
        </li>
        <li>
          ขูดหินปูน:
          การขูดหินปูนและเกลารากฟันเพื่อกำจัดคราบหินปูนที่สะสมอยู่ใต้เหงือก
        </li>
        <li>
          ถอนฟัน: สำหรับฟันที่ไม่สามารถรักษาได้ เช่น ฟันผุรุนแรงหรือฟันคุด
        </li>
        <li>
          ผ่าตัดแก้ไขความผิดปกติในช่องปาก: เช่น การผ่าฟันคุด
          การผ่าตัดกระดูกขากรรไกร และการแก้ไขพังผืดยึดในช่องปาก
        </li>
        <li>
          ให้คำปรึกษาเกี่ยวกับสุขภาพฟันและช่องปาก:
          การดูแลฟันและเหงือกอย่างถูกวิธี
          การเลือกใช้แปรงสีฟันและยาสีฟันที่เหมาะสม
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[2].name}</span>
        :
      </div>

      <div
        className={`grid ${
          specialClinic[2]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[2]?.vet.length > 0 &&
          specialClinic[2].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_4 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[3].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยความผิดปกติเกี่ยวกับกระดูกและข้อ: เช่น กระดูกหัก
          ข้อสะโพกเสื่อม และปัญหากระดูกสันหลัง
        </li>
        <li>
          การรักษาด้วยวิธีทางอายุรกรรมและการผ่าตัด: รวมถึงการผ่าตัดข้อเข่า
          การผ่าตัดข้อสะโพก และการผ่าตัดกระดูกสันหลัง
        </li>
        <li>
          เครื่องมือและอุปกรณ์ที่ทันสมัย: เช่น เครื่องเอกซเรย์ดิจิทัล,
          เครื่องเอกซเรย์คอมพิวเตอร์ (CT Scan), และการส่องกล้องในการผ่าตัด
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[3].name}</span>
        :
      </div>

      <div
        className={`grid ${
          specialClinic[3]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[3]?.vet.length > 0 &&
          specialClinic[3].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_5 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[4].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคหัวใจ: เช่น โรคหัวใจล้มเหลว
          โรคหัวใจเต้นผิดจังหวะ และโรคกล้ามเนื้อหัวใจ
        </li>
        <li>
          การตรวจทางรังสีวินิจฉัย: เช่น การเอกซเรย์ (X-ray)
          และการเอกซเรย์คอมพิวเตอร์ (CT Scan)
          เพื่อประเมินโครงสร้างและการทำงานของหัวใจ
        </li>
        <li>
          การตรวจคลื่นไฟฟ้าหัวใจ (ECG):
          เพื่อประเมินจังหวะการเต้นของหัวใจและตรวจหาความผิดปกติ
        </li>
        <li>
          การตรวจหัวใจด้วยคลื่นเสียงความถี่สูง (Echocardiogram):
          เพื่อดูโครงสร้างและการทำงานของหัวใจอย่างละเอียด
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[4].name}</span>
        :
      </div>

      <div
        className={`grid ${
          specialClinic[4]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[4]?.vet.length > 0 &&
          specialClinic[4].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_6 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[5].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคทางระบบประสาทและสมอง: เช่น โรคลมชัก,
          โรคหมอนรองกระดูกทับเส้นประสาท, และโรคกล้ามเนื้ออ่อนแรง
        </li>
        <li>
          การตรวจทางรังสีวินิจฉัย: เช่น การเอกซเรย์ (X-ray)
          และการเอกซเรย์คอมพิวเตอร์ (CT Scan)
          เพื่อประเมินโครงสร้างและการทำงานของระบบประสาท
        </li>
        <li>
          การตรวจคลื่นไฟฟ้าสมอง (EEG):
          เพื่อประเมินการทำงานของสมองและตรวจหาความผิดปกติ
        </li>
        <li>
          การรักษาทางอายุรกรรมและการผ่าตัด:
          รวมถึงการผ่าตัดกระดูกสันหลังและการรักษาด้วย
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[5].name}</span>
        :
      </div>

      <div
        className={`grid ${
          specialClinic[5]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[5]?.vet.length > 0 &&
          specialClinic[5].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_7 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[6].name}</span>
      </div>
      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคในแมว: เช่น โรคไวรัส FIV, FeLV, FIP, และ FPV
        </li>
        <li>
          ทีมสัตวแพทย์ที่มีประสบการณ์:
          ดูแลโดยสัตวแพทย์ที่มีความเชี่ยวชาญและประสบการณ์สูง
        </li>
        <li>
          ให้คำปรึกษาสุขภาพ: ให้คำแนะนำเกี่ยวกับการดูแลสุขภาพแมวในทุกช่วงอายุ
        </li>
        <li>
          แนะนำการเลี้ยงดูแลแมวอย่างถูกวิธี: เช่น การเลือกอาหารที่เหมาะสม,
          การดูแลขน, และการฝึกการขับถ่าย
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[6].name}</span>
        :
      </div>

      <div
        className={`grid ${
          specialClinic[6]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[6]?.vet.length > 0 &&
          specialClinic[6].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_8 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[7].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยโรคเนื้องอก: เช่น การตรวจทางเซลล์วิทยา (Cytology),
          การตัดชิ้นเนื้อ (Biopsy), และการทำอัลตราซาวด์ (Ultrasound)
          เพื่อประเมินลักษณะและตำแหน่งของเนื้องอก
        </li>
        <li>
          การรักษาด้วยเคมีบำบัด (Chemotherapy): ใช้ยาเพื่อทำลายเซลล์มะเร็ง
          สามารถให้ทางหลอดเลือดดำหรือรับประทาน
        </li>
        <li>
          การรักษาด้วยการผ่าตัด (Surgery):
          เหมาะสำหรับการกำจัดเนื้องอกที่มีขอบเขตชัดเจน
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[7].name}</span>
      </div>

      <div
        className={`grid ${
          specialClinic[7]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[7]?.vet.length > 0 &&
          specialClinic[7].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_9 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[8].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          การนวดกล้ามเนื้อด้วยคลื่นเสียง (Ultrasound Therapy):
          ช่วยลดอาการปวดและอักเสบของกล้ามเนื้อ
        </li>
        <li>
          การกระตุ้นกล้ามเนื้อด้วยไฟฟ้า (Electrical Stimulation):
          ช่วยเพิ่มความแข็งแรงและการทำงานของกล้ามเนื้อ
        </li>
        <li>
          การฟื้นฟูกล้ามเนื้อด้วยการเดินในลู่วิ่งน้ำ (Underwater Treadmill
          Therapy):
          ช่วยเพิ่มความแข็งแรงและความยืดหยุ่นของกล้ามเนื้อโดยลดแรงกดบนข้อต่อ
        </li>
        <li>
          การให้บริการเลเซอร์ (Laser Therapy): ช่วยลดอาการปวดและอักเสบ
          รวมถึงกระตุ้นการฟื้นฟูของเนื้อเยื่อ
        </li>
        <li>
          การจัดหารถเข็นสำหรับสัตว์พิการ:
          เพื่อช่วยให้สัตว์เลี้ยงที่มีปัญหาการเคลื่อนไหวสามารถเคลื่อนที่ได้สะดวกขึ้น
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[8].name}</span>
      </div>

      <div
        className={`grid ${
          specialClinic[8]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[8]?.vet.length > 0 &&
          specialClinic[8].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_10 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[9].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคต่อมไร้ท่อ: เช่น โรคเบาหวาน,
          ภาวะต่อมไทรอยด์ทำงานผิดปกติ, และภาวะต่อมหมวกไตทำงานผิดปกติ
        </li>
        <li>การรักษาโรคเบาหวาน: ด้วยการฉีดอินซูลินและการควบคุมอาหาร</li>
        <li>
          การรักษาภาวะต่อมไทรอยด์ทำงานผิดปกติ:
          ด้วยการให้ยาฮอร์โมนไทรอยด์สังเคราะห์หรือการผ่าตัด
        </li>
        <li>การรักษาภาวะต่อมหมวกไตทำงานผิดปกติ: ด้วยการใช้ยาหรือการผ่าตัด</li>
        <li>
          ให้คำปรึกษาและแนะนำการดูแลสัตว์ป่วย: เช่น การจัดการโภชนาการ,
          การออกกำลังกาย, และการเฝ้าติดตามอาการเพื่อป้องกันภาวะแทรกซ้อน
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">{specialClinic[9].name}</span>
      </div>

      <div
        className={`grid ${
          specialClinic[9]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[9]?.vet.length > 0 &&
          specialClinic[9].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_11 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[10].name}</span>
      </div>
      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคระบบทางเดินอาหาร: เช่น โรคกระเพาะอาหารอักเสบ,
          โรคลำไส้อักเสบ, และโรคกรดไหลย้อน
        </li>
        <li>
          ตรวจวินิจฉัยและรักษาโรคตับ: เช่น โรคตับอักเสบ, โรคตับแข็ง,
          และโรคมะเร็งตับ
        </li>
        <li>
          ตรวจวินิจฉัยและรักษาโรคทางเดินถุงน้ำดี: เช่น โรคนิ่วในถุงน้ำดี,
          โรคถุงน้ำดีอักเสบ, และโรคท่อน้ำดีอุดตัน
        </li>
        <li>
          การตรวจทางรังสีวินิจฉัย: เช่น การทำอัลตราซาวด์ (Ultrasound)
          และการเอกซเรย์ (X-ray) เพื่อประเมินความผิดปกติ
        </li>
        <li>
          การรักษาด้วยการผ่าตัด: สำหรับกรณีที่จำเป็น เช่น
          การผ่าตัดถุงน้ำดีและการผ่าตัดตับ
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">
          {specialClinic[10].name}
        </span>
      </div>

      <div
        className={`grid ${
          specialClinic[10]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[10]?.vet.length > 0 &&
          specialClinic[10].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_12 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[11].name}</span>
      </div>
      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคไต: เช่น โรคไตวายเฉียบพลันและเรื้อรัง,
          โรคติดเชื้อทางเดินปัสสาวะ
        </li>
        <li>
          การฟอกเลือดโดยใช้เครื่องไตเทียม (Hemodialysis):
          สำหรับสัตว์ป่วยที่มีปัญหาไตทำงานผิดปกติ
        </li>
        <li>
          การตรวจทางรังสีวินิจฉัย: เช่น การทำอัลตราซาวด์ (Ultrasound)
          และการเอกซเรย์ (X-ray) เพื่อประเมินความผิดปกติ
        </li>
        <li>
          การรักษาด้วยการผ่าตัด: สำหรับกรณีที่จำเป็น เช่น
          การผ่าตัดไตและการผ่าตัดทางเดินปัสสาวะ
        </li>
        <li>
          ให้คำปรึกษาและแนะนำการดูแลสัตว์ป่วย:
          เพื่อให้การดำรงชีวิตมีความเหมาะสมและลดการเกิดอาการแทรกซ้อน
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">
          {specialClinic[11].name}
        </span>
      </div>

      <div
        className={`grid ${
          specialClinic[11]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[11]?.vet.length > 0 &&
          specialClinic[11].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_13 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[12].name}</span>
      </div>
      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          การฝังเข็มเพื่อการกระตุ้นจุดเฉพาะบนร่างกาย: ช่วยกระตุ้นระบบต่างๆ
          ในร่างกายให้เกิดการเยียวยาตัวเอง
        </li>
        <li>
          การรักษาปัญหาระบบกระดูกและกล้ามเนื้อ: เช่น ข้อสะโพกเสื่อม,
          โรคหมอนรองกระดูกเสื่อม
        </li>
        <li>
          การแก้ไขระบบประสาทผิดปกติ: เช่น
          การบาดเจ็บที่ทำให้ตัวสัตว์ไม่มีความรู้สึก, ลดปวดจากโรคประสาท
        </li>
        <li>การรักษาโรคทางเดินหายใจ: เช่น โรคหอบหืด</li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">
          {specialClinic[12].name}
        </span>
      </div>

      <div
        className={`grid ${
          specialClinic[12]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[12]?.vet.length > 0 &&
          specialClinic[12].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_14 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[13].name}</span>
      </div>
      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจสุขภาพทั่วไป: ตรวจวินิจฉัยและรักษาความผิดปกติในสัตว์เลี้ยงพิเศษ
          เช่น สัตว์เลื้อยคลาน นก และสัตว์เลี้ยงขนาดเล็กอื่นๆ
        </li>
        <li>
          บริการด้านอายุรกรรม: การรักษาโรคเรื้อรังและเฉียบพลันในสัตว์เลี้ยงพิเศษ
          เช่น โรคทางเดินหายใจ โรคทางเดินอาหาร และโรคผิวหนัง
        </li>
        <li>
          บริการด้านศัลยกรรม:
          การผ่าตัดเพื่อรักษาความผิดปกติและการบาดเจ็บในสัตว์เลี้ยงพิเศษ
          โดยสัตวแพทย์ที่มีความเชี่ยวชาญและประสบการณ์
        </li>
        <li>
          ให้คำปรึกษาเกี่ยวกับการจัดการและการเลี้ยงสัตว์พิเศษ:
          ให้คำแนะนำเกี่ยวกับการดูแลสุขภาพ การให้อาหาร
          และการจัดการสิ่งแวดล้อมที่เหมาะสมสำหรับสัตว์เลี้ยงพิเศษ
        </li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">
          {specialClinic[13].name}
        </span>
      </div>

      <div
        className={`grid ${
          specialClinic[13]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[13]?.vet.length > 0 &&
          specialClinic[13].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const Clinic_15 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81]">
        <span>{specialClinic[14].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจ วินิจฉัย และรักษาโรคสัตว์น้ำเช่น: กบ หมาน้ำ (Axolotl Pet)
          เต่าหมูบิน เต่าคองู ปลาน้ำจืด และ ปลาน้ำเค็ม ทุกชนิด
        </li>
        <li>
          การผ่าตัดรักษา: ผ่าเนื้องอกผิวหนัง ผ่าเนื้องอกในช่องท้อง เป็นต้น
        </li>
        <li>ให้คำปรึกษาเกี่ยวกับการเลี้ยงและการจัดการ</li>
        <li>มีบริการที่พักสัตว์น้ำป่วยโดยเฉพาะ</li>
        <li>การรักษาด้วยยา</li>
        <li>ศัลยกรรมตกแต่ง</li>
      </div>

      <div className="text-[#9E76B3] text-xl">
        สัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน {""}
        <span className="drop-shadow-lg border-b">
          {specialClinic[14].name}
        </span>
        :
      </div>

      <div
        className={`grid ${
          specialClinic[14]?.vet.length === 1
            ? "grid-cols-1 "
            : "grid-cols-1 lg:grid-cols-2 "
        }  gap-5`}
      >
        {specialClinic[14]?.vet.length > 0 &&
          specialClinic[14].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-full rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover  w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                  <div className="font-semibold text-white border-b flex justify-between">
                    <span>ตารางลงตวรวจ</span>
                    <span>{item.floot}</span>
                    <span>ห้อง: {item.room}</span>
                  </div>
                  <div className="flex flex-col gap-y-2 text-sm">
                    {item?.Checkin.date.length > 0 &&
                      item.Checkin.date.map((date, index) => (
                        <div className="flex gap-x-2">
                          <div className="flex gap-x-2 text-[#0F4D81] font-bold">
                            <i className="fa fa-calendar-week"></i>
                            {date.day}
                          </div>
                          <div className="flex gap-x-2 text-[#0F4D81]">
                            <i className="fa fa-clock"></i>
                            {date.time} น.
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};
